import { Calculator } from "lucide-react";

// Calculator Teaser - Centered and Strong
export const CalculatorTeaser = () => (
  <section className="py-10 sm:py-12 lg:py-16 bg-[#1C1C1C]">
    <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
      <h2 className="text-2xl lg:text-3xl font-semibold text-white tracking-tight mb-3">
        Model Your Pipeline
      </h2>
      <p className="text-zinc-300 mb-8">
        See how SDR performance impacts CAC, LTV, and payback.
      </p>
      <a
        href="/resources/sdr-economics#calculator"
        className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-[#0A0A0A] rounded-lg font-semibold hover:bg-[#E8C547] transition-all"
        data-testid="calculator-cta"
      >
        <Calculator className="w-5 h-5" />
        Open Calculator
      </a>
    </div>
  </section>
);

export default CalculatorTeaser;
